import request from '../../../shared/request'

export function getViolations(job_id) {
  return request(`/job/violations/${job_id}/`)
}

export function getViolationAttachments(violation_id) {
  return request(`/job/violations/${violation_id}/attachments/`)
}

export function uploadViolationAttachments(payload) {
  return request(`/job/violations/${payload.violationId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function createViolation(payload) {
  return request(`/job/violations/${payload.jobId}/`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function updateViolation(payload) {
  return request(`/job/violations/${payload.violation_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateAttachmentDescription(payload) {
  return request(`/job/violations/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteViolation(payload) {
  return request(`/job/violations/${payload.violation_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteViolationAttachment(payload) {
  return request(`/job/violations/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editViolationStatus(payload) {
  return request(`/job/violations/${payload.violationId}/status`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/violations.js